import { Navigation, Login, Logout, Register } from "./navigation";
import { Dashboard } from "./dashboard";
import { Settings } from "./settings";
import { Intake } from "./intake";
import { AnimalList } from "./animal_list";
import { MyAnimals } from "./my_animals";
import { Animal } from "./animal";
import { Organization } from "./organization";
import { Account } from "./account";
import Calendar from "./calendar/calendar";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { DialogProvider } from "./dialogs/dialog_context";
import { ToasterProvider } from "./toaster/toaster_context";
let router = createBrowserRouter([
  {
    path: "/",
    element: <Navigation />,
    children: [
      { path: "/", element: <Dashboard /> },
      { path: "search", element: <AnimalList /> },
      { path: "myAnimals", element: <MyAnimals /> },
      { path: "animal/:id", element: <Animal /> },
      { path: "organization", element: <Organization /> },
      { path: "intake", element: <Intake /> },
      { path: "account", element: <Account /> },
      { path: "calendar", element: <Calendar /> },
      { path: "settings", element: <Settings /> },
    ],
  },
  { path: "login", element: <Login /> },
  { path: "logout", element: <Logout /> },
  { path: "register/:id", element: <Register /> },
]);

function App() {
  return (
    <DialogProvider>
      <ToasterProvider>
        <RouterProvider router={router} />
      </ToasterProvider>
    </DialogProvider>
  );
}

export default App;
